import { useState } from 'react';
import { Modal } from '../../components/common';
import { IconSave } from '../../components/icons';
import { Switch } from './shell';

export default function RoomDialog({ room, onSubmit, onClose }) {
  const [value, setValue] = useState(() => ({
    nameTh: room?.name_th || '',
    code: room?.code || '',
    isPrivate: !!room?.is_private,
    isActive: room ? room.is_active !== false : true,
  }));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const set = (key, next) => setValue((current) => ({ ...current, [key]: next }));

  const submit = async () => {
    if (!value.nameTh.trim()) return setError('กรุณากรอกชื่อห้อง');
    if (!value.code.trim()) return setError('กรุณากรอกรหัสย่อห้อง');
    setBusy(true);
    setError('');
    try {
      await onSubmit({
        nameTh: value.nameTh.trim(),
        code: value.code.trim(),
        isPrivate: value.isPrivate,
        isActive: value.isActive,
      });
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <Modal
      title={room ? 'แก้ไขห้องนวด' : 'สร้างห้องนวด'}
      onClose={onClose}
      footer={(
        <>
          <button className="btn-outline" onClick={onClose} disabled={busy}>ยกเลิก</button>
          <button className="btn-solid" onClick={submit} disabled={busy}>
            <IconSave size={16} /> {busy ? 'กำลังบันทึก…' : 'บันทึก'}
          </button>
        </>
      )}
    >
      {error && <div className="login-error">{error}</div>}
      <div className="grid-2">
        <div className="field">
          <label>ชื่อห้อง <span style={{ color: 'var(--red-600)' }}>*</span></label>
          <input value={value.nameTh} onChange={(event) => set('nameTh', event.target.value)} />
        </div>
        <div className="field">
          <label>รหัสย่อห้อง <span style={{ color: 'var(--red-600)' }}>*</span></label>
          <input value={value.code} onChange={(event) => set('code', event.target.value)} />
        </div>
      </div>
      <Switch
        label="ส่วนตัว"
        hint="ไม่ส่วนตัว / ส่วนตัว"
        on={value.isPrivate}
        onChange={(next) => set('isPrivate', next)}
      />
      <Switch
        label="สถานะ"
        hint="ไม่ใช้งาน / ใช้งาน"
        on={value.isActive}
        onChange={(next) => set('isActive', next)}
      />
    </Modal>
  );
}
